const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the event assignment
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('eventAssignWait', ['Application', 'Authorization', 'Users', 'Events', '$translate', function(Application, Authorization, Users, Events, $translate) {
  return {
    restrict: 'E',
    scope: {
      event: '=',
      showHide: '=',
      type: '=',
      updateLists: '&'
    },
    template: require('../../templates/directives/event-assign-wait.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.exclusions = [];
      self.queryChanged = false;
      self.per_page = 20;
      self.endOfLine = true;
      self.selectionCount = 0;
      self.restrictions = {};
      self.creating = false;
      var assignList = {
        in: {},
        nin: {},
        queries: []
      };
      var queryOptions = {
        linked_locations: 'array',
        linked_departments: 'array',
        $or: 'textMatch',
        role: 'text',
        manager_email: 'text',
        hired: 'date',
        createdAt: 'date',
        last_login: 'date'
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_departments,linked_locations,job_title,last_login,createdAt,hired,manager_email',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name'
        };
        if ($scope.manager && $scope.manager.email) {
          q.manager_email = $scope.manager.email;
        }
        return q;
      };

      self.query = getStandardQuery();

      self.load = function () {
        self.disableScroll = true;

        Users.findExcludingSet(self.query, {users: self.exclusions}).$promise
        .then(function (users) {
          if (users.length < self.per_page) {
            self.endOfLine = true;
          }
          if (self.query.page === 1 || !self.users) {
            self.users = users;
          } else {
            self.users = self.users.concat(users);
          }
          if (!self.endOfLine) {
            self.disableScroll = false;
          }
        }).catch(function (error) {
          console.log('Error getting users:', error);
        });
      };
      self.nextPage = function() {
        self.query.page++;
        self.load();
      };
      self.onQuery = function(opts) {
        self.endOfLine = false;
        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.queryChanged = false;
          self.load();
          return;
        }
        self.queryChanged = true;
        self.query.page = 1;
        for (var key in opts) {
          self.query[key] = opts[key];
        }

        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        per_page: 20,
        nextAllowed: false,
        show: false,
        getUsers: function() {
          var items = {};
          items.queries = assignList.queries;
          items.in = Object.keys(assignList.in);
          items.nin = [].concat(Object.keys(assignList.nin), self.exclusions);
          self.preview.show = true;

          Users.segmentationList({
            fields: '_id,first_name,last_name,email,full_name,image,job_title,linked_locations,linked_departments,role,hired,createdAt,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            page: self.preview.page,
            per_page: self.preview.per_page
          }, items).$promise
          .then(function(users) {
            self.preview.users = users;
            if (users.length < self.preview.per_page) {
              self.preview.nextAllowed = false;
              return;
            }
            self.preview.nextAllowed = true;
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        }
      };

      // Functions for selecting and deselecting users to assign
      self.userClick = function(user) {
        if (self.isUserChecked(user)) {
          self.uncheckUser(user);
          return;
        }
        self.checkUser(user);
      };
      self.checkUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.nin[id]) {
          delete assignList.nin[id];
        }
        assignList.in[id] = true;
        getCount();
      };
      self.uncheckUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.in[id]) {
          delete assignList.in[id];
        }
        assignList.nin[id] = true;
        getCount();
      };
      self.selectAll = function() {
        var queryAddition = {};
        if (self.query._id) {
          self.checkUser(null, self.query._id);
          return;
        }
        if ($scope.manager) {
          self.query.manager_email = $scope.manager.email
        }
        for (var key in queryOptions) {
          if (self.query[key]) {
            queryAddition[key] = self.query[key];
          }
        }
        assignList.queries.push(queryAddition);
        getCount();
      };
      self.isUserChecked = function(user) {
        if (assignList.in[user._id]) {
          self.individuals[user._id] = true;
          return true;
        }
        if (assignList.nin[user._id]) {
          self.individuals[user._id] = false;
          return false;
        }
        return self.checkQueries(user);
      };

      self.checkQueries = function(user) {
        if (!assignList.queries || !assignList.queries.length) {
          self.individuals[user._id] = false;
          return false;
        }
        for (var i = 0; i < assignList.queries.length; i++) {
          var current = assignList.queries[i];
          var currentFailed = false;
          for (var key in queryOptions) {
            if (current[key]) {
              if (!self.fieldCheck(user, key, current[key])) {
                currentFailed = true;
                break;
              }
            }
          }
          if (!currentFailed) {
            self.individuals[user._id] = true;
            return true;
          }
        }
        self.individuals[user._id] = false;
        return false;
      };

      self.fieldCheck = function(user, field, option) {
        var text;
        if (!field || typeof field !== 'string') {
          return false;
        }

        switch (field) {
          case 'linked_locations':
            if (!user.linked_locations || !user.linked_locations[0] || !user.linked_locations[0]._id || option.indexOf(user.linked_locations[0]._id) === -1) {
              return false;
            }
            return true;
          case 'linked_departments':
            if (!user.linked_departments || !user.linked_departments[0] || !user.linked_departments[0]._id || option.indexOf(user.linked_departments[0]._id) === -1) {
              return false;
            }
            return true;
          case '$or':
            text = option.split(',')[4];
            if (user.full_name && user.full_name.indexOf(text) !== -1 || user.email && user.email.indexOf(text) !== -1 || user.job_title && user.job_title.indexOf(text) !== -1) {
              return true;
            }
            return false;
          case 'role':
            if (user.role && user.role === option) {
              return true;
            }
            return false;
          case 'hired':
            text = new Date(option.slice(10));
            if (user.hired && new Date(user.hired) > text) {
              return true;
            }
            return false;
          case 'createdAt':
            text = new Date(option.slice(10));
            if (user.createdAt && new Date(user.createdAt) > text) {
              return true;
            }
            return false;
          case 'last_login':
            text = new Date(option.slice(10));
            if (user.last_login && new Date(user.last_login) > text) {
              return true;
            }
            return false;
          default:
            return false;
        }
      };

      var getCount = function() {
        var items = {};
        items.queries = assignList.queries;
        items.in = Object.keys(assignList.in);
        items.nin = [].concat(Object.keys(assignList.nin), self.exclusions);
        self.overload = false;

        Users.segmentationCount({}, items).$promise
        .then(function(count) {
          self.selectionCount = count.count ? count.count : 0;
          self.queryChanged = false;
          if ($scope.type === 'attendees') {
            if ((self.selectionCount + $scope.event.attendees.length) > $scope.event.max_attendees) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: 'The number of selected users would exceed the allowed number of seats for this event. Please either expand the allowed users in the event edit view or reduce the number of selections.'});
              self.overload = true;
            }
          }
          if ($scope.type === 'waitlist') {
            if ((self.selectionCount + $scope.event.waitlist.length) > $scope.event.max_wait) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: 'The number of selected users would exceed the allowed number of waitlist seats for this event. Please either expand the allowed users in the event edit view or reduce the number of selections.'});
              self.overload = true;
            }
          }
        });
      };
      self.createAssignments = function() {
        self.creating = true;
        var user = Authorization.getAuthToken().user._id;
        if (!user) {
          return;
        }
        var body = {
          assignees: {},
          assigner: user,
          content: $scope.event._id
        };
        body.assignees.queries = assignList.queries;
        body.assignees.in = Object.keys(assignList.in);
        body.assignees.nin = Object.keys(assignList.nin);
        body.type = $scope.type === 'attendees' ? 'assign' : $scope.type === 'waitlist' ? 'wait' : null;

        Events.queryJoinWait({}, body).$promise
        .then(function(results) {
          $scope.updateLists({evnt: results});
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['manage.assign.content_confirmMessage'] });
          self.preview.show = false;
          $scope.showHide = false;
          self.clearChoices();
          $scope.success = true;
          self.creating = false;
        });
      };

      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList = {
          in: {},
          nin: {},
          queries: []
        };
        self.individuals = {};
        self.selectionCount = 0;
        self.queryChanged = false;
        self.clearQuery = true;
        $scope.clearAll();
      };
      self.cancel = function() {
        $scope.showHide = false;
        self.clearChoices();
      };
      self.resizeWindow = function() {
        self.windowHeight = $window.innerHeight - (document.querySelector('#scroll-selection').clientHeight);
      };
      angular.element($window).bind('resize', function() {
        self.resizeWindow();
        $scope.$apply();
      });
      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize');
      });
      $scope.$watch('showHide', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          if (!$scope.type) {
            $scope.showHide = false;
            return;
          }
          self.exclusions = $scope.event.attendees || [];
          if ($scope.type === 'waitlist' && $scope.event.waitlist && $scope.event.waitlist.length) {
            self.exclusions = self.exclusions.concat($scope.event.waitlist);
          }
          delete self.restrictions.manager_email;
          if ($scope.manager && $scope.manager.email) {
            self.restrictions.manager_email = $scope.manager.email;
          }
          if ((!self.users || !self.users.length) && $scope.manager) {
            self.query = getStandardQuery();
            self.load();
          }
          setTimeout(function() {
            // settimeout is necessary to take affect after elements have been resized
            self.resizeWindow();
            $scope.$apply();
          }, 100);
        }
      });

      $translate(['manage.assign.content_confirmMessage']).then(function(results){

        self.translations = results;
      });

    }],
    controllerAs: 'assignments'
  };
}]);
